
















































































































import axios from 'axios'
import {Mixins, Component} from "vue-property-decorator";
import att_mixins from "../../mixins/att";

interface edit_modal {
    IDC: string,
    Source: string,
    IP: string,
    Port: string,
    Username: string,
    Password: string
}

const regExp_Name = (rule: any, value: any, callback: any) => {
    let pPattern = new RegExp("[`~!@#$^&*()={}':;',\\[\\]<>/?~！@#￥……&*（）——{}【】‘；：”“'。，、？]");
    if (pPattern.test(value)) {
        callback(new Error('特殊字符仅可使用|与-'))
    } else {
        callback()
    }
};

const regExp_password = (rule: any, value: any, callback: any) => {
    let pPattern = new RegExp("[`?？^$]");
    if (pPattern.test(value)) {
        callback(new Error('密码中不得含有? @ ^ $'))
    } else {
        callback()
    }
};

@Component
export default class database_manager extends Mixins(att_mixins) {
    columns = [
        {
            title: '连接名称',
            key: 'Source'
        },
        {
            title: '查询数据源',
            key: 'IsQuery',
            slot: 'is_query'
        },
        {
            title: '数据库地址',
            key: 'IP'
        },
        {
            title: '环境',
            key: 'IDC'
        },
        {
            title: '操作',
            key: 'action',
            width: 300,
            slot: 'action'
        }
    ];
    // 添加表单验证规则
    ruleInline = {
        add: [
            {required: true, message: '请选择对应环境', trigger: 'change'}
        ],
        name: [
            {
                required: true,
                message: '请填写连接名称',
                trigger: 'blur',

            },
            {
                validator: regExp_Name,
                trigger: 'blur'
            }
        ],
        ip: [{
            required: true,
            message: '请填写连接地址',
            trigger: 'blur'
        }],
        username: [{
            required: true,
            message: '请填写用户名',
            trigger: 'blur'
        }],
        port: [{
            required: true,
            message: '请填写端口',
            trigger: 'blur'
        }],
        password: [
            {
                required: true,
                message: '请填写密码',
                trigger: 'blur'
            },
            {
                validator: regExp_password,
                trigger: 'blur'
            }
        ]
    };
    comList = [];
    edit_base_info = {} as edit_modal;

    resetForm() {
        this.formItem = this.$config.clearObj(this.formItem)
    }

    testConnection() {
        axios.put(`${this.$config.url}/management_db/test`, {
            'ip': this.formItem.ip,
            'user': this.formItem.username,
            'password': this.formItem.password,
            'port': parseInt(this.formItem.port)
        })
            .then(res => {
                this.$config.notice(res.data)
            })
            .catch(error => {
                this.$config.err_notice(this, error)
            })
    }

    addConnection() {
        let is_validate: any = this.$refs['formValidate'];
        is_validate.validate((valid: boolean) => {
            if (valid) {
                axios.post(`${this.$config.url}/management_db/add`, {
                    'source': this.formItem.name,
                    'idc': this.formItem.add,
                    'ip': this.formItem.ip,
                    'user': this.formItem.username,
                    'password': this.formItem.password,
                    'port': parseInt(this.formItem.port),
                    'isQuery': this.formItem.isquery
                })
                    .then(res => {
                        this.$config.notice(res.data);
                        this.getPageInfo(this.current);
                        is_validate.resetFields()
                    })
                    .catch(error => {
                        this.$config.err_notice(this, error)
                    });
            }
        })
    }

    viewConnectionModal(row: edit_modal) {
        this.is_open = true;
        this.edit_base_info = row
    }

    delConnection(vl: { Source: string; }) {
        let step = this.current;
        if (this.table_data.length === 1) {
            step = step - 1
        }
        axios.delete(`${this.$config.url}/management_db/del/${vl.Source}`)
            .then(res => {
                this.$config.notice(res.data);
                this.getPageInfo(step)
            })
            .catch(error => {
                this.$config.err_notice(this, error)
            })
    }

    getPageInfo(vl = 1) {
        axios.get(`${this.$config.url}/management_db/fetch/?page=${vl}&con=${JSON.stringify(this.query)}`)
            .then(res => {
                this.table_data = res.data.data;
                this.page_number = parseInt(res.data.page);
                this.comList = res.data.custom;
            })
            .catch(error => {
                this.$config.err_notice(this, error)
            })
    }

    modifyBase() {
        let x = JSON.parse(JSON.stringify(this.edit_base_info));
        x.Port = parseInt(x.Port);
        x.IsQuery = 0;
        axios.put(`${this.$config.url}/management_db/edit`, {
            'data': x
        })
            .then(res => this.$config.notice(res.data))
            .catch(err => this.$config.err_notice(this, err))
    }

    queryData() {
        this.query.valve = true;
        this.getPageInfo()
    }

    queryCancel() {
        this.$config.clearObj(this.formItem);
        this.getPageInfo()
    }

    mounted() {
        this.getPageInfo()
    }
}
